const DECIMAL_PRECISION = 10000; // 10^4 = 4 decimal places

export class TagBoxCoordMapper {
    static pixToPercent({ left, top, width, height }, containerWidth, containerHeight) {
        return {
            left:   Math.round(left   / containerWidth  * 100 * DECIMAL_PRECISION) / DECIMAL_PRECISION,
            top:    Math.round(top    / containerHeight * 100 * DECIMAL_PRECISION) / DECIMAL_PRECISION,
            width:  Math.round(width  / containerWidth  * 100 * DECIMAL_PRECISION) / DECIMAL_PRECISION,
            height: Math.round(height / containerHeight * 100 * DECIMAL_PRECISION) / DECIMAL_PRECISION,
        };
    }

    static percentToPx({ left, top, width, height }, containerWidth, containerHeight) {
        return {
            left:   containerWidth  / 100 * left,
            top:    containerHeight / 100 * top,
            width:  containerWidth  / 100 * width,
            height: containerHeight / 100 * height,
        };
    }
}
